import { BackgroundWrapper } from "../../atoms/backgroundWrapper/BackgroundWrapper";
import { Button } from "../../atoms/button/Button";
import { Text } from "../../atoms/text/Text";
import style from "./selectOption.module.scss";
import { Container } from "../../atoms/container/Container";
import { SelectPatient } from "../selectPatient/SelectPatient";
import { InsuranceCard } from "../../molecules/insuranceCard/InsuranceCard";
import { useSelectOPtion } from "../../../hooks/useSelectOPtion/UseSelectOption";
import { useLogisticsData } from "../../../hooks/uselogisitcData/UseLogisticsData";
import { LogisticsAddressTab } from "../logisticsAddressTab/LogisticsAddressTab";
import { useFetchTicket } from "../../../hooks/useFetchTicket/UseFetchTicket";
import { AgentNotes } from "../../molecules/agentNotes/AgentNotes";
import { SelectPoc } from "../selectPoc/SelectPoc";
import { AgentScript } from "../../atoms/agentScript/AgentScript";

export const SelectOption = () => {
  const {
    selectedButton,
    selectedOption,
    ButtonType,
    OptionType,
    data,
    handleButtonClick,
    handleOptionClick,
    handleAmbulanceBooking
  } = useSelectOPtion();
  const {
    isAddressSelected,
    selectedAddress,
    setSelectedAddress,
    handleAddressSelection,
    handleEditSelectedAddress,
    isHospitalSelected,
    selectedHospital,
    handleEditHospital,
    renderHospitalUi,
    value,
    handleIncreaseRadius,
    marks,
    patientAddress,
    hospitalLists,
    handleSelectHospital,
    handleStartEmergency,
    officePreferred
  } = useLogisticsData();

  const { getTicketUpdateData } = useFetchTicket();
  const callBySeniorPayload = {
    ticketType: "Call By Senior",
    ticketStatus: "Work in progress",
  }

  return (
    <>
      <div className={style.wrapper}>
        <BackgroundWrapper>
          <div className={style.flex}>
            <Text className={style.title} text="Select Option" />

            {/* MODULE 2 - Intent Identification */}
            <AgentScript text="May I understand how I can assist you today?" />

            <div className={style.btn_flex}>
              <Button
                onClick={() => handleButtonClick('INSURANCE_HOSPITAL')}
                text="Insurance/Hospital Query"
                className={
                  selectedButton === ButtonType.INSURANCE_HOSPITAL ? style.btn_dis_select : style.btn
                }
              />
              <Button
                text="Demo call"
                onClick={() => handleButtonClick('DEMO')}
                className={
                  selectedButton === ButtonType.DEMO ? style.btn_dis_select : style.btn
                }
              />
              <Button
                text="Ambulance Booking"
                onClick={() => handleButtonClick('AMBULANCE')}
                className={
                  selectedButton === ButtonType.AMBULANCE ? style.btn_dis_select : style.btn
                }
              />
              <Button
                text="Test Call"
                onClick={() => handleButtonClick('CUSTOMER')}
                className={
                  selectedButton === ButtonType.CUSTOMER ? style.btn_dis_select : style.btn
                }
              />
              <Button
                text="Pococare general enquiry"
                onClick={() => handleButtonClick('POCOCARE')}
                className={
                  selectedButton === ButtonType.POCOCARE ? style.btn_dis_select : style.btn
                }
              />
            </div>

            {/* MODULE 4 - Ambulance Booking transition script */}
            {selectedButton === ButtonType.AMBULANCE && (
              <AgentScript text="We will surely help you with ambulance booking. I will take a few details and arrange the ambulance accordingly." />
            )}

            {/* MODULE 3 - Generic query script */}
            {/* {(selectedButton === ButtonType.INSURANCE_HOSPITAL) && (
              <AgentScript text="I will help you with your query." />
            )} */}

            {/* MODULE 3 - Insurance/TPA specific script */}
            {selectedButton === ButtonType.INSURANCE_HOSPITAL && (
              <AgentScript text="I will assist you with your insurance-related query to best our ability, we can share your e-card number and TPA details in case it has been made available with us. For details, you should call your insurance company helpline or the TPA helpline." />
            )}

            {/* MODULE 3 - Pococare specific script */}
            {selectedButton === ButtonType.POCOCARE && (
              <AgentScript text="I will help you understand Pococare services." />
            )}

            {selectedButton === ButtonType.INSURANCE_HOSPITAL && (
              <div className={style.btn_flex}>
                <Button
                  text="Insurance details"
                  onClick={() => handleOptionClick('INSURANCE')}
                  className={
                    (selectedOption !== OptionType.INSURANCE) ? style.btn_option : style.btn_option_disable
                  }
                />
                <Button
                  onClick={() => handleOptionClick('HOSPITAL')}
                  text="Nearest Hospital"
                  className={
                    (selectedOption !== OptionType.HOSPITAL) ? style.btn_option : style.btn_option_disable
                  }
                />
              </div>
            )}
          </div>
        </BackgroundWrapper>

        {selectedButton !== ButtonType.POCOCARE && (
          <BackgroundWrapper>
            <Container>
              <SelectPatient />
            </Container>
          </BackgroundWrapper>
        )}

        {selectedOption === OptionType.INSURANCE && (
          <BackgroundWrapper>
            <Container>
              <InsuranceCard data={data?.insurancePolicies || []} />
            </Container>
          </BackgroundWrapper>
        )}

        {selectedOption === OptionType.HOSPITAL && (
          getTicketUpdateData?.patient?.id ? (
            <BackgroundWrapper className={style.space}>
              <Container>
                <LogisticsAddressTab
                  component="GeneralEnq"
                  isAddressSelected={isAddressSelected}
                  selectedAddress={selectedAddress}
                  setSelectedAddress={setSelectedAddress}
                  handleAddressSelection={handleAddressSelection}
                  handleEditSelectedAddress={handleEditSelectedAddress}
                  isHospitalSelected={isHospitalSelected}
                  selectedHospital={selectedHospital}
                  handleEditHospital={handleEditHospital}
                  renderHospitalUi={renderHospitalUi}
                  value={value}
                  handleIncreaseRadius={handleIncreaseRadius}
                  marks={marks}
                  patientAddress={patientAddress}
                  hospitalLists={hospitalLists}
                  handleSelectHospital={handleSelectHospital}
                  handleStartEmergency={handleStartEmergency}
                  officePreferred={officePreferred}
                />
              </Container>
            </BackgroundWrapper>
          ) : (
            <>Please select the patient to view nearby hospitals</>
          )
        )}

        {selectedButton === ButtonType.AMBULANCE && <SelectPoc />}
        {selectedButton === ButtonType.SENIOR && <AgentNotes additionalData={callBySeniorPayload} />}
        {selectedButton === ButtonType.POCOCARE && (
          <>
            <AgentNotes showCaseStudy={false} additionalData={{ ticketType: 'Pococare Service Query', ticketStatus: 'Completed' }} />
          </>
        )}

        {/* MODULE 3 - Closure script for query tabs */}
        {(selectedButton === ButtonType.INSURANCE_HOSPITAL || selectedButton === ButtonType.POCOCARE) && (
          <BackgroundWrapper>
            <Container>
              <AgentScript text="Is there anything else I can assist you with?" />
            </Container>
          </BackgroundWrapper>
        )}

        {selectedButton === ButtonType.AMBULANCE && <Button
          text="Proceed"
          onClick={() => handleAmbulanceBooking()}
          className={style.button}
        />}
      </div>
    </>
  );
};
